// Hardcoded Aria workday schedules.
// Replace these with a dynamic thing (permissioned UI + data source) when ready.

export const ARIA_WORKDAY_RULES = [
  { buildings: ["1", "2"], workdays: 124, story: "3 story" },
  { buildings: ["5", "6"], workdays: 156, story: "3 story" },
  { buildings: ["3", "4"], workdays: 169, story: "4 story" },
];

export function getAriaWorkdays(buildingNumber) {
  const key = normalizeBuildingNumber(buildingNumber);
  if (!key) return null;
  const rule = ARIA_WORKDAY_RULES.find(entry => entry.buildings.includes(key));
  return rule ? rule.workdays : null;
}

function normalizeBuildingNumber(value) {
  if (!value) return "";
  const match = String(value).match(/\d+/);
  return match ? match[0] : String(value).trim();
}
